import {
    Button,
    CircularProgress,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import setDate from "../../utils/setDate";
import LaunchIcon from "@material-ui/icons/Launch";
import convertToCurrency from "../../utils/convertToCurrency";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import React from "react";
import {Alert} from "@material-ui/lab";
import useStyles from "../../styles/styles";


const ApiRequestDecisionTable = ({data, loading, error, openModal}) => {
    const classes = useStyles();


    if (loading) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"campaign-decision-logs"}>Api Request
                    Decisions</Typography>
                <Paper className={classes.paper}>
                    <CircularProgress color="inherit"/>
                </Paper>
            </>
        );
    }

    if (error || !data) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left" id={"campaign-decision-logs"}>Api Request
                    Decisions</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"campaign-decision-logs"}>Api Request
                Decisions</Typography>
            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Timestamp</TableCell>
                            <TableCell variant="head">Elapsed</TableCell>
                            <TableCell variant="head">Servicer</TableCell>
                            <TableCell variant="head">Campaign</TableCell>
                            <TableCell variant="head">Type</TableCell>
                            <TableCell variant="head">Status</TableCell>
                            <TableCell variant="head">Strategy</TableCell>
                            <TableCell variant="head">Log Type</TableCell>
                            <TableCell variant="head">Tier Min</TableCell>
                            <TableCell variant="head">Price&nbsp;Point</TableCell>
                            <TableCell variant="head">Billable</TableCell>
                            <TableCell variant="head">Payable</TableCell>
                            <TableCell variant="head">Request</TableCell>
                            <TableCell variant="head">Response</TableCell>
                            <TableCell variant="head">Result</TableCell>
                            <TableCell variant="head">Status Code</TableCell>
                            <TableCell variant="head">Vendor&nbsp;Session&nbsp;Id</TableCell>
                            <TableCell variant="head">Vendor&nbsp;Message</TableCell>
                            <TableCell variant="head">Publisher&nbsp;Timeout</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map(entry => (
                            <TableRow key={entry.entityId}>
                                <TableCell
                                    variant="body">{entry.requestTimestamp !== null ? setDate(entry.requestTimestamp) : 'null'}</TableCell>
                                <TableCell variant="body">{(entry.elapsedTime / 1000).toFixed(2)}s</TableCell>
                                <TableCell variant="body">{entry.servicer}</TableCell>
                                <TableCell variant="body">
                                    {entry.campaignId}
                                    {entry.campaignId === 'olp' ? (
                                        <IconButton
                                            href={`http://secure.tools.partnerweekly.com/application?id=${entry.vendorSessionId}&mode=live`}>
                                            <LaunchIcon/>
                                        </IconButton>
                                    ) : null}
                                </TableCell>
                                <TableCell variant="body">{entry.campaignType} {entry.type}</TableCell>
                                <TableCell variant="body">{entry.status}</TableCell>
                                <TableCell variant="body">{entry.strategy}</TableCell>
                                <TableCell variant="body">{entry.type}</TableCell>
                                <TableCell variant="body"
                                           align="right">{entry.tierMin !== null ? convertToCurrency(entry.tierMin) : 'N/A'}</TableCell>
                                <TableCell variant="body"
                                           align="right">{entry.pricePoint !== null ? convertToCurrency(entry.pricePoint) : 'N/A'}</TableCell>
                                <TableCell variant="body"
                                           align="right">{entry.billable !== null ? convertToCurrency(entry.billable) : 'N/A'}</TableCell>
                                <TableCell variant="body"
                                           align="right">{entry.payable !== null ? convertToCurrency(entry.payable) : 'N/A'}</TableCell>
                                <TableCell variant="body">
                                    <Button onClick={() => openModal({
                                        title: `Request: ${setDate(entry.requestTimestamp)}`,
                                        pre: entry.request
                                    })}>
                                        <LaunchIcon/>
                                    </Button>
                                </TableCell>
                                <TableCell variant="body">
                                    <Button onClick={() => openModal({
                                        title: `Response: ${setDate(entry.responseTimestamp)}`,
                                        pre: entry.response,
                                    })}>
                                        <LaunchIcon/>
                                    </Button>
                                </TableCell>
                                <TableCell variant="body">
                                    <Button onClick={() => openModal({
                                        title: `Result - ${entry.statusCode}: ${setDate(entry.requestTimestamp)}`,
                                        pre: entry.result
                                    })}>
                                        <LaunchIcon/>
                                    </Button>
                                </TableCell>
                                <TableCell variant="body">
                                    {entry.statusCode}
                                </TableCell>
                                <TableCell variant="body">{entry.vendorSessionId || 'N/A'}</TableCell>
                                <TableCell variant="body"
                                           style={{whiteSpace: "nowrap"}}>{entry.vendorMessage}</TableCell>
                                <TableCell variant="body">{entry.publisherTimeout ?
                                    <CheckCircleOutlineIcon aria-checked={true}/> :
                                    <RadioButtonUncheckedIcon aria-checked={false}/>}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        </>
    )
}

export default ApiRequestDecisionTable